<script>
	// Island: the only JS the theme needs. Mounted fresh by www/src/islands/entry.ts from
	// empty props — nothing env/time dependent may live in props, and the SSR markup must
	// match the initial client markup (CSS picks the icon from :root[data-theme]).
	import { onMount } from "svelte";
	import Hydrator from "@reperio-news/core.components/Hydrator.svelte";

	let theme = null;

	onMount(() => {
		theme = document.documentElement.getAttribute("data-theme") || "light";
	});

	function toggle() {
		const root = document.documentElement;
		const next = root.getAttribute("data-theme") === "dark" ? "light" : "dark";
		root.setAttribute("data-theme", next);
		theme = next;
		try {
			localStorage.setItem("af-theme", next);
		} catch (_e) {
			// private mode / storage blocked: the choice just does not persist
		}
		const color = next === "dark" ? "#15171b" : "#f7f3ec";
		document
			.querySelectorAll('meta[name="theme-color"]')
			.forEach((m) => m.setAttribute("content", color));
	}
</script>

<Hydrator component="ThemeToggle" props={{}} hydrate={!__ADMIN__}>
	<button
		type="button"
		class="af-toggle af-pill af-pill--tap"
		data-theme-toggle
		aria-pressed={theme === null ? undefined : theme === "dark"}
		title="Schimbă tema"
		on:click={toggle}
	>
		<svg class="af-toggle__sun" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
			<circle cx="12" cy="12" r="4" />
			<path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
		</svg>
		<svg class="af-toggle__moon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
			<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
		</svg>
		<span class="sr-only">Schimbă tema (luminoasă / întunecată)</span>
	</button>
</Hydrator>

<style lang="scss">
	.af-toggle {
		padding: 0;
		width: 44px;
		justify-content: center;
		color: var(--af-ink-muted);
		background: transparent;

		&:hover {
			color: var(--af-ink);
			background: var(--af-surface-sunk);
		}
	}

	@media (min-width: 768px) {
		.af-toggle {
			width: 32px;
			min-height: 32px;
		}
	}

	/* dark → offer the sun (switch to light); light → offer the moon */
	:global(:root[data-theme="dark"]) .af-toggle__moon {
		display: none;
	}

	:global(:root:not([data-theme="dark"])) .af-toggle__sun {
		display: none;
	}
</style>
